class NumberFormatter {
  format(value, percent = false) {
    let formatted = Number(value).toFixed(2);
    if (percent) {
      formatted = Number(value).toFixed(0);
    }
    return formatted;
  }
}
const numberFormatter = new NumberFormatter();
export default numberFormatter;